// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tNDur {
    height: 100%;
    width: 100%;
    background-color: #000000;
    display: flex;
    flex-direction: column;
}

.ooCfL {
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #000000;
}

.IXb7d {
    width: 40px;
    height: 40px;
    border: 3px solid rgba(255, 255, 255, 0.3);
    border-top-color: #ffffff;
    border-radius: 50%;
    animation: KZcv7 1s linear infinite;
}

@keyframes KZcv7 {
    to {
        transform: rotate(360deg);
    }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,0CAA0C;IAC1C,yBAAyB;IACzB,kBAAkB;IAClB,mCAAkC;AACtC;;AAEA;IACI;QACI,yBAAyB;IAC7B;AACJ","sourcesContent":[".container {\n    height: 100%;\n    width: 100%;\n    background-color: #000000;\n    display: flex;\n    flex-direction: column;\n}\n\n.loadingContainer {\n    height: 100%;\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background-color: #000000;\n}\n\n.spinner {\n    width: 40px;\n    height: 40px;\n    border: 3px solid rgba(255, 255, 255, 0.3);\n    border-top-color: #ffffff;\n    border-radius: 50%;\n    animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n    to {\n        transform: rotate(360deg);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `tNDur`,
	"loadingContainer": `ooCfL`,
	"spinner": `IXb7d`,
	"spin": `KZcv7`
};
export default ___CSS_LOADER_EXPORT___;
